.agent-avatar-container {
    min-width: 75px;
}
